import { applySnapshot, getSnapshot, types as t } from 'mobx-state-tree';

export const RecurringFileListModel = t.model('RecurringFileListModel', {
  id: t.string,
  status: t.string,
  batch_name: t.maybeNull(t.string),
  file_url: t.maybeNull(t.string),
  scheduled_at: t.maybeNull(t.string),
  total_amount: t.maybeNull(t.number),
  total_amount_string: t.maybeNull(t.string),
  total_record: t.maybeNull(t.number),
  created_at: t.string,
  created_by: t.string,
  updated_at: t.maybeNull(t.string),
  updated_by: t.maybeNull(t.string),
  perm_is_approved: t.maybeNull(t.string),
  perm_is_partial_approved: t.maybeNull(t.string),
  reject_reason: t.maybeNull(t.string),
});

export const RecurringFileModel = t
  .model('RecurringFileModel', {
    list: t.array(RecurringFileListModel),
    pagination: t.model('Pagination', {
      total_count: t.optional(t.number, 0),
      current_page: t.optional(t.number, 0),
      total_pages: t.optional(t.number, 0),
    }),
  })
  .actions((self) => {
    let initialState = {};
    return {
      afterCreate() {
        initialState = getSnapshot(self);
      },
      reset() {
        applySnapshot(self, initialState);
      },
    };
  });

export default RecurringFileModel;
